import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { HolidayGroup } from '@classes/holiday/holiday-group';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { HolidayGroupsService } from '@services/holiday-groups.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-holiday-group-edit',
  templateUrl: './holiday-group-edit.component.html',
  styleUrls: ['./holiday-group-edit.component.scss']
})
export class HolidayGroupEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() holidayGroup: HolidayGroup;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private holidayGroupsSrv: HolidayGroupsService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initForm();
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.holidayGroup) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const holidayCopy: HolidayGroup = JSON.parse(JSON.stringify(this.holidayGroup));
    holidayCopy.name = this.editForm.value.name;

    this.holidayGroupsSrv.put(holidayCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.holidayGroup = new HolidayGroup(
      this.editForm.value.name
    );

    this.holidayGroupsSrv.post(this.holidayGroup)
      .subscribe(
        () => this.isLoading = false,
        () => this.holidayGroup = null
      );
  }

  private initForm(): void {
    let name = "";

    if (this.holidayGroup) {
      name = this.holidayGroup.name;
    }

    this.editForm = this.fb.group({
      name: [name, Validators.required]
    });
  }
}
